export const ACTIONS = {
    START_FETCHING_ZIP_DATA: 'START_FETCHING_ZIP_DATA',
    FETCHED_ZIP_DATA: 'FETCHED_ZIP_DATA',
    SET_ERRORS: 'SET_ERRORS',
    SET_ZIP_CODE: 'SET_ZIP_CODE',
    SET_RISK_AREA: 'SET_RISK_AREA',
    SET_SHOW_RESULT: 'SET_SHOW_RESULT'
}